// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var assetBundleBuildings = {
    buildings_0: require("../assets/packed/buildings/buildings-0.json"),
    buildings_1: require("../assets/packed/buildings/buildings-1.json"),
    buildings_10: require("../assets/packed/buildings/buildings-10.json"),
    buildings_11: require("../assets/packed/buildings/buildings-11.json"),
    buildings_12: require("../assets/packed/buildings/buildings-12.json"),
    buildings_13: require("../assets/packed/buildings/buildings-13.json"),
    buildings_14: require("../assets/packed/buildings/buildings-14.json"),
    buildings_2: require("../assets/packed/buildings/buildings-2.json"),
    buildings_3: require("../assets/packed/buildings/buildings-3.json"),
    buildings_4: require("../assets/packed/buildings/buildings-4.json"),
    buildings_5: require("../assets/packed/buildings/buildings-5.json"),
    buildings_6: require("../assets/packed/buildings/buildings-6.json"),
    buildings_7: require("../assets/packed/buildings/buildings-7.json"),
    buildings_8: require("../assets/packed/buildings/buildings-8.json"),
    buildings_9: require("../assets/packed/buildings/buildings-9.json"),
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/assetBundleBuildings.ts
// module id = 1713
// module chunks = 3